import React from 'react';
import { Dialog, useTheme } from '@mui/material';
import { MdClose, MdCheckCircle } from 'react-icons/md';

const SocketNotificationModal = ({ open, onClose, message, type = 'success' }) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';

    const getTypeConfig = () => {
        switch (type) {
            case 'success':
                return {
                    icon: <MdCheckCircle size={48} />,
                    color: isDark ? '#10b981' : '#059669',
                    bgColor: isDark ? '#064e3b' : '#d1fae5',
                    title: 'Connected Successfully'
                };
            case 'error':
                return {
                    icon: <MdClose size={48} />,
                    color: isDark ? '#ef4444' : '#dc2626',
                    bgColor: isDark ? '#7f1d1d' : '#fee2e2',
                    title: 'Connection Error'
                };
            default:
                return {
                    icon: <MdCheckCircle size={48} />,
                    color: isDark ? '#10b981' : '#059669',
                    bgColor: isDark ? '#064e3b' : '#d1fae5',
                    title: 'Notification'
                };
        }
    };

    const config = getTypeConfig();

    return (
        <Dialog
            open={false}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    backgroundColor: isDark ? '#1a1a2e' : '#ffffff',
                    color: isDark ? '#e5e7eb' : '#1f2937'
                },
            }}
        >
            <div className="card mb-0">
                <div className="card-header d-flex justify-content-between align-items-center border-bottom"
                    style={{
                        backgroundColor: isDark ? '#16213e' : '#f9fafb',
                        borderColor: isDark ? '#2d3748' : '#e5e7eb'
                    }}
                >
                    <h6 className="card-title mb-0" style={{ color: isDark ? '#f3f4f6' : '#111827' }}>
                        Socket Connection
                    </h6>
                    <button
                        type="button"
                        className={`btn btn-sm p-1 d-flex justify-content-center align-items-center ${
                            isDark ? 'btn-dark text-light' : 'btn-light'
                        }`}
                        onClick={onClose}
                        style={{
                            backgroundColor: isDark ? '#2d3748' : '#f3f4f6',
                            color: isDark ? '#e5e7eb' : '#374151',
                            border: `1px solid ${isDark ? '#4a5568' : '#d1d5db'}`
                        }}
                    >
                        <MdClose size={18} />
                    </button>
                </div>

                <div className="card-body text-center py-24">
                    <div
                        className="w-80-px h-80-px rounded-circle d-flex justify-content-center align-items-center mx-auto mb-16"
                        style={{
                            backgroundColor: config.bgColor,
                            color: config.color
                        }}
                    >
                        {config.icon}
                    </div>
                    
                    <h5 className="fw-bold mb-12" style={{ color: isDark ? '#f3f4f6' : '#111827' }}>
                        {config.title}
                    </h5>
                    
                    <p className="text-secondary-light mb-24" style={{ 
                        color: isDark ? '#9ca3af' : '#6b7280',
                        fontSize: '0.95rem'
                    }}>
                        {message || 'Successfully connected to server!'}
                    </p>

                    <button
                        className="btn btn-primary px-48 py-12 radius-8 fw-medium"
                        onClick={onClose}
                        style={{
                            minWidth: '120px'
                        }}
                    >
                        OK
                    </button>
                </div>
            </div>
        </Dialog>
    );
};

export default SocketNotificationModal;
